import type { Zone } from 'luxon';

import { DateTime } from 'luxon';
import { toDateTime } from '@/plugins/time';

export function formatEventEndTime(
  time: DateConvertible | null | undefined,
  timeZone?: string | Zone | null,
  formatOptions?: Intl.DateTimeFormatOptions | null
) {
  return formatEventTime(time, timeZone, formatOptions, 23, 59, 59);
}

export function formatEventStartTime(
  time: DateConvertible | null | undefined,
  timeZone?: string | Zone | null,
  formatOptions?: Intl.DateTimeFormatOptions | null
) {
  return formatEventTime(time, timeZone, formatOptions, 0, 0, 1);
}

function formatEventTime(
  time: DateConvertible | null | undefined,
  timeZone: string | Zone | null | undefined,
  formatOptions: Intl.DateTimeFormatOptions | null | undefined,
  omittedHour: number,
  omittedMinute: number,
  omittedSecond: number
): string | null {
  const dt = toDateTime(time);
  if (
    !dt ||
    (dt.hour === omittedHour && dt.minute === omittedMinute && dt.second === omittedSecond)
  ) {
    return null;
  }
  return (timeZone ? dt.setZone(timeZone) : dt).toLocaleString(
    formatOptions || DateTime.TIME_SIMPLE
  );
}
